/* eslint-disable import/no-cycle */
import { filters, titleFilter } from './filters.js';
import { filtersToString } from '../utils/filtersToString.js';
import { stringToFilters } from '../utils/stringToFilters.js';

/*
    our simple routing functions:

        Update the URL when the filters change,

    or

        Update the filters when the URL changes!
*/
function updateURLFromFilters() {

    const url = new URL(document.location);
    const pathname = url.pathname;
    const params = new URLSearchParams(url.search);

    params.set('filters', filtersToString(filters));
    params.set('text', titleFilter.value);

    window.history.replaceState({}, '', pathname + '?' + params);

}

function updateFiltersFromUrl(params) {

    const filterString = params.get('filters');

    if (filterString) {

        stringToFilters(filterString);

    }

    const textString = params.get('text');

    if (textString) {

        titleFilter.value = textString;

    }

}

function getReadingModeFromUrl() {

    const url = new URL(document.location);
    const params = new URLSearchParams(url.search);
    const versionMap = {
        Live: 'LIVE',
        Stage: 'DRAFT',
    };
    const stage = params.get('stage') ?? 'Live';
    return Object.prototype.hasOwnProperty.call(versionMap, stage) ? versionMap[stage] : 'LIVE';

}

export const routing = {

    updateURLFromFilters,
    updateFiltersFromUrl,
    getReadingModeFromUrl,

};
